export enum OsasTrialPeriod {
    continue = 'Continueren; meer metingen nodig (3 maanden)',
    stop = 'Afbreken; therapie beëindigen',
    successful = 'Succesvol; therapie voortzetten',
}
